"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "zone": {
    "2370c180": [{
      "hkey": "f96a32e0",
      "slug": "zone",
      "name": "Zone",
      "primary": true,
      "skipSearch": false
    }],
    "cusato": [{
      "hkey": "f96a32e0",
      "slug": "zone",
      "name": "Zone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ed08119c": [{
      "hkey": "6376ce5e",
      "slug": "centro-cusato",
      "name": "Centro-Cusato",
      "primary": true,
      "skipSearch": false
    }],
    "centro": [{
      "hkey": "6376ce5e",
      "slug": "centro-cusato",
      "name": "Centro-Cusato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "f23e5a52": [{
      "hkey": "eceaac8f",
      "slug": "rucca-chigazzolo",
      "name": "Rucca-Chigazzolo",
      "primary": true,
      "skipSearch": false
    }],
    "rucca": [{
      "hkey": "eceaac8f",
      "slug": "rucca-chigazzolo",
      "name": "Rucca-Chigazzolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;